import { useIntl } from 'react-intl'

import { useNavigate } from '@tanstack/react-router'

import { Button } from '@/components/atoms/Button'
import { TableCell } from '@/components/atoms/Table'
import { type JudicialRecord } from '@/components/model'

export const ProvincialSearchStatusCell = ({ record }: { record: JudicialRecord }) => {
  const navigate = useNavigate()
  const intl = useIntl()

  if (record.provincialSearchStatus === 'processing' || record.provincialSearchStatus === 'retrieving') {
    return (
      <TableCell className="text-center">
        <span className="text-sm text-gray-700">
          {intl.formatMessage({ id: `judicial.results.status.${record.provincialSearchStatus}` })}
        </span>
      </TableCell>
    )
  }

  if (
    record.provincialSearchStatus === 'completed' &&
    record.provincial?.numberOfResults &&
    record.provincial.numberOfResults > 0
  ) {
    return (
      <TableCell className="text-center">
        <div className="flex flex-col items-center gap-2">
          <Button
            size="sm"
            variant="default"
            onClick={() => navigate({ to: '/judicial/$recordId', params: { recordId: record._id } })}
            className="h-8 bg-gray-700 px-3 py-1 text-sm text-white hover:bg-gray-600">
            {intl.formatMessage({ id: 'judicial.results.resultsCount' }, { count: record.provincial.numberOfResults })}
          </Button>
        </div>
      </TableCell>
    )
  }

  return (
    <TableCell className="text-center">
      <span className="text-sm text-gray-700">
        {intl.formatMessage({ id: `judicial.results.status.${record.provincialSearchStatus}` })}
      </span>
    </TableCell>
  )
}
